import { useMutation, useQueryClient } from 'react-query';

import {
  GROUP_SUBSCRIPTION_KEY,
  GroupSubscriptionType,
  UpdateGroupSubscriptionParams,
  updateGroupSubscription,
} from '../utils/backend-api/groupSubscription';

export default function useGroupSubscriptionUpdate(groupSubscriptionType: GroupSubscriptionType) {
  const queryClient = useQueryClient();
  const { mutate, isLoading, isError } = useMutation(
    (params: UpdateGroupSubscriptionParams) => updateGroupSubscription(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GROUP_SUBSCRIPTION_KEY, groupSubscriptionType]);
      },
    }
  );
  return { mutate, isLoading, isError };
}
